const PostCard = ({ title, content, image, reactions, comments }) => (
    <div className="max-w-[400px] bg-white p-4 border rounded-lg shadow-sm mb-4">
      <div className="flex items-center mb-2">
        <div className="w-12 h-12 text-white flex items-center justify-center mr-2">
            <img src="/Images/logo/Logo-2 1old.png" alt="Logo" className="w-full h-full object-cover rounded-full" />
        </div>
        <div>
          <p className="font-semibold">LogicSpice Consultancy Pvt. Ltd.</p>
          <p className="text-xs text-gray-600">3,559 followers</p>
          <p className="text-xs text-gray-600">2w</p>

        </div>
      </div>
      <p className="text-sm text-gray-700">{content}</p>
      {image && <img src={image} alt="Post image" className="w-full h-48 object-cover my-2 rounded" />}
      <div className="flex justify-between text-sm text-gray-600 mt-2">
        <span><i class="fa fa-thumbs-up"></i>{" "}{reactions}</span>
        <span>{comments} comments</span>
      </div>
    </div>
  );
  
  export default PostCard;